import script from "./VergleichHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./VergleichHeader.vue?vue&type=script&setup=true&lang=js"

import "./VergleichHeader.vue?vue&type=style&index=0&id=4e3ae5f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e3ae5f1"]])

export default __exports__